<div class="page" [class.assignment-active]="assignmentMode">
    <div class="header" fxLayoutAlign="space-between center">
        <div fxLayout="row wrap" fxLayoutGap="8px">
            <div class="field">
                <label>Kunde</label>
                <ng-select class="control" [(ngModel)]="filter.jucCustomerId" (ngModelChange)="onFiltersChange()"
                           [clearable]="false">
                    <ng-option *ngFor="let customer of customers" [value]="customer.id">{{ customer.customerName }}
                    </ng-option>
                </ng-select>
            </div>

            <div class="field">
                <label>Servicetechniker</label>
                <ng-select class="control" [(ngModel)]="filter.installationPersonEmail"
                           (ngModelChange)="onFiltersChange()" [clearable]="false">
                    <ng-option value="null">alle</ng-option>
                    <ng-option value="ohne Zuordnung">ohne Zuordnung</ng-option>
                    <ng-option *ngFor="let technician of serviceTechnicians"
                               [value]="technician.email">{{ technician.email }}
                    </ng-option>
                </ng-select>
            </div>

            <div class="field">
                <label>Kalenderwoche</label>
                <ng-select class="control" [(ngModel)]="filter.installationWeekFilter"
                           (ngModelChange)="onFiltersChange()" [clearable]="false">
                    <ng-option *ngFor="let week of installationWeekFilterOptions" [value]="week.value">
                        KW: {{ week.label }}
                    </ng-option>
                </ng-select>
            </div>

            <div class="field">
                <label>Status</label>
                <ng-select class="control" [(ngModel)]="filter.siteStatuses" (ngModelChange)="onFiltersChange()"
                           [multiple]="true">
                    <ng-option *ngFor="let status of statusOptions"
                               [value]="status.value">{{ status.label }}
                    </ng-option>
                </ng-select>
            </div>

            <div class="field">
                <input class="control" placeholder="Suche (Straße, PLZ, Ort, Zusatzname, Seriennummer)"
                       [(ngModel)]="filter.searchTerm" (ngModelChange)="onFiltersChange()">
            </div>
        </div>
        <div class="actions">
            <div class="legend-wrapper">
                <button class="legend-btn" (click)="showLegend = !showLegend">Legende</button>
                <div class="legend" *ngIf="showLegend">
                    <div class="legend-head">
                        <h3>Legende</h3>
                        <button type="button" class="close" (click)="showLegend = false">
                            <i class="ju ju-close"></i>
                        </button>
                    </div>
                    <div class="rows">
                        <div class="legend-item">
                            <span class="pin ungeplant"></span>
                            <span>Ungeplante Installationen</span>
                        </div>
                        <div class="legend-item">
                            <span class="pin geplant"></span>
                            <span>Geplante Installationen</span>
                        </div>
                        <div class="legend-item">
                            <span class="pin fertig"></span>
                            <span>Abgeschlossene Installationen</span>
                        </div>
                        <div class="legend-item">
                            <span class="pin kommentar"></span>
                            <span>Kommentar</span>
                        </div>
                        <div class="legend-item">
                            <span class="pin gateway"></span>
                            <span>Montierte Gateways</span>
                        </div>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="isPlanner()">
                <button class="primary"
                        [disabled]="assignmentMode || !isPlannerAndIsACustomerSelected()"
                        (click)="enableAssignmentMode()">
                    Zuordnung starten
                </button>
                <button class="primary"
                        [disabled]="!isPlannerAndIsACustomerSelected()"
                        (click)="openCreateSiteModal()">
                    + Neue Liegenschaft
                </button>
            </ng-container>
            <button class="primary"
                    [disabled]="!sites.length"
                    (click)="exportData()">
                Daten exportieren
            </button>
        </div>
    </div>

    <div class="table-wrap" *ngIf="filteredCount; else emptyState">
        <table>
            <thead>
            <tr>
                <th class="col-ng-select" *ngIf="assignmentMode"></th>
                <th class="col-status">Status</th>
                <th>Kunde / Adresse</th>
                <th class="col-gateway">Seriennummer</th>
                <th class="col-ap">Ansprechpartner</th>
                <th class="col-tech">Servicetechniker</th>
                <th>KW</th>
                <th>Steuerung</th>
            </tr>
            </thead>

            <tbody>
            <tr *ngFor="let site of pagedSites; trackBy: trackBySite"
                (click)="showDetails(site)">
                <td class="col-ng-select" *ngIf="assignmentMode">
                    <label class="assignment-checkbox">
                        <input type="checkbox"
                               [checked]="isSiteMarkedForAssignment(site)"
                               (change)="toggleSiteAssignment(site)">
                        <span></span>
                    </label>
                </td>
                <td class="col-status">
          <span class="status">
            <span class="pin" [ngClass]="getStatus(site).cssClass"></span>
              {{ getStatus(site).label }}
          </span>
                </td>

                <td>
                    <div class="kunde-tag">{{ site.customerName.replace('[IMMO] ', '') || '-' }}</div>
                    <div class="addr">
                        {{ site.street }} {{ site.streetNumber }}
                        <small>
                            {{ site.postCode }} {{ site.city }}{{ site.additionalName ? ' · ' + site.additionalName : '' }}
                        </small>
                    </div>
                </td>

                <td class="col-gateway">
                    <span class="gw" *ngIf="site.serialNumbers?.length; else noSerial">{{ serialNumbers(site) }}</span>
                    <ng-template #noSerial><span class="empty">–</span></ng-template>
                </td>

                <td class="col-ap">
                    <ng-container *ngIf="site.contactPersonName; else noAp">
                        {{ site.contactPersonName }} <span class="empty">({{ site.contactPersonNumber || '–' }})</span>
                    </ng-container>
                    <ng-template #noAp><span class="empty">–</span></ng-template>
                </td>

                <td class="col-tech">
                    <ng-container *ngIf="site.installationPersonEmail; else noTech">{{ site.installationPersonEmail }}
                    </ng-container>
                    <ng-template #noTech><span class="empty">nicht zugeordnet</span></ng-template>
                </td>

                <td>
                    <ng-container *ngIf="site.installationWeek; else noKw">
                        <span class="kw-val">KW {{ site.installationWeek }}</span>
                    </ng-container>
                    <ng-template #noKw><span class="empty">–</span></ng-template>
                </td>

                <td>
          <span class="badge" [ngClass]="installedControlLabel(site) === 'Ja' ? 'ja' : 'nein'">
            {{ installedControlLabel(site) }}
          </span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>

    <ng-template #emptyState>
        <div class="empty-state">
            <h3>Keine Liegenschaften gefunden</h3>
            <p>Passe die Filter an oder ändere die Suchkriterien.</p>
        </div>
    </ng-template>

    <div class="pager" *ngIf="filteredCount">
        <div class="info">Zeige <b>{{ pageFrom }}–{{ pageTo }}</b> von <b>{{ filteredCount }}</b> Liegenschaften</div>
        <div class="spacer"></div>

        <div class="psize">
            Pro Seite
            <ng-select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
                <ng-option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</ng-option>
            </ng-select>
        </div>

        <div class="pages">
            <span class="page-icon page-icon--left-end" (click)="goToFirstPage()"
                  [ngClass]="isFirstPage ? 'inactive' : 'active'"></span>
            <span class="page-icon page-icon--left" (click)="goToPreviousPage()"
                  [ngClass]="isFirstPage ? 'inactive' : 'active'"></span>
            <span class="page-info">{{ page }} / {{ totalPages }}</span>
            <span class="page-icon page-icon--right" (click)="goToNextPage()"
                  [ngClass]="isLastPage ? 'inactive' : 'active'"></span>
            <span class="page-icon page-icon--right-end" (click)="goToLastPage()"
                  [ngClass]="isLastPage ? 'inactive' : 'active'"></span>
        </div>
    </div>

    <div class="assignment-bar" *ngIf="assignmentMode" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="assignment-count">
            <span class="assignment-count__num">{{ sitesMarkedForAssignment.length }}</span>
            ausgewählt
        </div>
        <div class="divider"></div>

        <div class="assignment-field" fxLayout="row" fxLayoutAlign="center center">
            <label>Zuordnen an</label>
            <ng-select class="control"
                       [(ngModel)]="assignmentInstallationPersonEmail">
                <ng-option *ngFor="let technician of serviceTechnicians"
                           [value]="technician.email">
                    {{ technician.email }}
                </ng-option>
            </ng-select>
        </div>

        <div class="assignment-field" fxLayout="row" fxLayoutAlign="center center">
            <label>Kalenderwoche</label>
            <input class="control control--week" type="number" min="1" max="53"
                   [(ngModel)]="assignmentInstallationWeek">
        </div>

        <div class="spacer"></div>

        <button class="secondary" (click)="cancelAssigment()">Abbrechen</button>
        <button class="primary"
                [disabled]="!canSitesMarkedForAssignmentBeSaved()"
                (click)="updateMarkedSites()">
            Speichern
        </button>
    </div>
</div>

<app-create-site-detail-modal [modalControl]="modalCreateSiteDetail" [isPlanner]="isPlanner()"
                              [site]="createSite" (updatedSite)="onSiteUpdated()">
</app-create-site-detail-modal>
<app-site-detail-modal [modalControl]="modalSiteDetail"
                       [site]="selectedSite"
                       [isPlanner]="isPlanner()"
                       (updatedSite)="onSiteUpdated()">
</app-site-detail-modal>
